// http请求返回码
const HttpCode = {
  Success: 200,
  ValidateFailed: 203,
  Error: 500,

  LicenseError: 40001
};

export default HttpCode;